import React from 'react';
import { CtaButton } from './CtaButton';
import { Avatar } from './Avatar';
import { HERO_IMAGE, HERO_IMAGE_ALT } from '../data/product';
import { coaches, avatarColors } from '../data/coaches';
const chips = ['6 Volumes', '5 Bonuses', '96 ready-to-run practices', 'U8–U10 & U12–U14', 'Field boys & girls', '60 · 75 · 90 min'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Open it, print it, run it'];

/**
 * Proof line under the CTA. Swap for a real rating + buyer count
 * once you have verified reviews.
 */
const PROOF_LINE = <>
    Built for <span className="font-semibold text-white" data-id="element-121" data-mp="saruosa8z4d0">volunteer, parent &amp; club coaches</span> of
    U8–U14 teams in the US, Canada, UK &amp; Australia
  </>;
export function Hero() {
  return <section className="sunset-field relative w-full overflow-hidden" data-id="element-122" data-mp="3d1aafpn8alfx">
      <div className="field-lines pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-123" data-mp="3cz5to748dry8" />
      <div className="relative mx-auto w-full max-w-6xl px-4 pb-12 pt-6 sm:px-5 sm:pb-16 lg:pb-20 lg:pt-12" data-id="element-124" data-mp="384jud2bfbpui">
        <div className="grid gap-7 lg:grid-cols-[1.05fr_.95fr] lg:items-center lg:gap-x-14 lg:gap-y-6" data-id="element-125" data-mp="3j6od1nctwsro">
          <div className="lg:col-start-1 lg:row-start-1" data-id="element-126" data-mp="39acy0plutotj">
            <p className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1 text-[10px] font-semibold uppercase tracking-[1.6px] text-white/80 sm:text-[11px]" data-id="element-127" data-mp="399tex5kgwudx">
              <span className="h-2 w-2 rounded-full bg-gold" aria-hidden="true" data-id="element-128" data-mp="30ggdtgc92mgr" />
              No-Lines Lacrosse · for youth lacrosse coaches
            </p>
            <h1 className="mt-4 font-display text-[40px] font-bold uppercase leading-[.95] tracking-tight text-white sm:text-6xl lg:text-[68px] xl:text-[76px]" data-id="element-129" data-mp="2qkdcudt4wtve">
              Every youth practice,{' '}
              <span className="mark-slash" data-id="element-130" data-mp="2hinbaf5jgejw">already planned.</span>
            </h1>
          </div>

          <div className="lg:col-start-1 lg:row-start-2" data-id="element-131" data-mp="2lla6mq1f4hlu">
            <p className="max-w-xl text-[15px] leading-relaxed text-white/80 sm:text-base lg:text-lg" data-id="element-132" data-mp="2lmv00cbzxui4">
              96 ready-to-run practices for U8–U14 teams, built so no kid waits
              in line. Drills, cues and fixes in 60, 75 and 90-minute versions.
              Open it, print it, run it — even if you&apos;ve never played.
            </p>

            <div className="mt-6 w-full max-w-md lg:mx-0" data-id="element-133" data-mp="de6o0r03e1ks">
              <CtaButton data-id="element-134" data-mp="1b0vwnjpavcfm">Get No-Lines Lacrosse</CtaButton>
            </div>
          </div>

          <div className="-mt-2 lg:col-start-2 lg:row-span-4 lg:row-start-1 lg:mt-0 lg:self-center" data-id="element-135" data-mp="1ayjiziqkro8d">
            <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} width={2048} height={1365} className="mx-auto aspect-[3/2] w-full rounded-2xl border border-white/10 object-cover shadow-book sm:rounded-3xl" data-id="element-136" data-mp="15zzwnh82kafh" />
          </div>

          <div className="lg:col-start-1 lg:row-start-3" data-id="element-137" data-mp="3lqm2xztl37vg">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" data-id="element-138" data-mp="3hqkbsklh5wuf">
              <ul className="flex -space-x-2.5" data-id="element-139" data-mp="1xacgp6hknput">
                {coaches.slice(0, 5).map((coach, i) => <li key={`${coach.name}-${i}`} data-id="element-140" data-mp="21bpm5fgr5r17" data-mpi={i}>
                    <Avatar name={coach.name} src={coach.avatar} color={avatarColors[i]} className="h-9 w-9 border-2 border-navy sm:h-10 sm:w-10" data-id="element-141" data-mp="269zkfyxrx7r1" />
                  </li>)}
              </ul>
              <p className="max-w-sm text-xs leading-relaxed text-white/70" data-id="element-142" data-mp="2kydv2w1fm0i5">{PROOF_LINE}</p>
            </div>

            <ul className="mt-5 grid gap-2 text-xs text-white/65 sm:flex sm:flex-wrap sm:gap-x-5" data-id="element-143" data-mp="2p08ufuzsy3ta">
              {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-144" data-mp="2tysiq21vbrot">
                  <span className="h-1.5 w-1.5 flex-none rounded-full bg-gold" data-id="element-145" data-mp="unj0xedciwmf" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="lg:col-start-1 lg:row-start-4" data-id="element-146" data-mp="4b477td2c4jg">
            <ul className="flex flex-wrap gap-1.5 sm:gap-2" data-id="element-147" data-mp="49jdu72hirn6">
              {chips.map(chip => <li key={chip} className="rounded-full border border-white/15 bg-navy-deep/40 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-white/75 sm:px-3 sm:py-1.5 sm:text-[11px]" data-id="element-148" data-mp="3vhfa7v1mvfdf">
                  {chip}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}